module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter6"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block10"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p223"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps-rw",
    staticStyle: {
      "font-size": "82%"
    }
  }, [_vm._v("HEY LAY NAKED")]), _vm._v(" together in the forward compartment, the sheets twined around them messily. Parker slept, his breathing slow and even. Camaro slipped free of the bed and went to where his shorts lay on the floor. She came up with his wallet and leafed through it. There were fifty-seven dollars in cash, his driver’s license, a trio of business cards from other fishing outfits, and a photograph.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p224"
    }
  }, [_vm._v("She looked at the picture. It showed a young girl of eight or nine on a beach, corn-silk hair blowing in a sudden gust off the water, and a more youthful Parker half-caught in the frame. The girl was laughing, and he was laughing, and the entire moment was washed in sun and pleasure. Camaro touched the girl’s face once and then put the picture away. She returned Parker’s wallet to his shorts and then climbed back into bed.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p225"
    }
  }, [_vm._v("Parker murmured slightly and took a shuddery breath through his nose. Camaro looked down at Parker’s feet, at the colorless bands of skin that marked where his sandal straps lay, and she nudged one foot with her own. She felt him wake. He chuckled. “Watch it,” he said. “I’m ticklish.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p226"
    }
  }, [_vm._v("“Where?” Camaro asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p227"
    }
  }, [_vm._v("“All over. Don’t get me started.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("“I won’t.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("She could feel him watching her, but she didn’t look back at him, choosing instead to look out past their feet to the galley beyond and the wooden door that closed off the back deck from below. The door had a circular window, and through that she could see the fighting chair waiting.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("“You know, when I said you could earn a little extra, this wasn’t what I was talking about,” Parker said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p231"
    }
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p232"
    }
  }, [_vm._v("“I can’t really remember the last time somebody…you know, gave me an invitation.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p233"
    }
  }, [_vm._v("Now she did turn to him, and she saw that the nerves were gone from him for the first time. His features were softer, the stress lines shallower. He was more handsome that way. “I don’t do that for everybody,” Camaro told him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p234"
    }
  }, [_vm._v("“I wasn’t saying anything.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p235"
    }
  }, [_vm._v("“Okay, then. Don’t.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p236"
    }
  }, [_vm._v("Her left leg was above the sheets and Parker pointed at a spot on her midthigh. It was a long scar with a head like a comet at the end, and it stood slightly raised from the tan skin, marring her. “What’s that?” he asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p237"
    }
  }, [_vm._v("“A scar,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p238"
    }
  }, [_vm._v("“What kind of scar?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p239"
    }
  }, [_vm._v("“A bullet scar,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p240"
    }
  }, [_vm._v("“A bullet scar? You got shot?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p241"
    }
  }, [_vm._v("“Yeah. I have another one right here, on my shoulder. See that there on my side? That’s one, too.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p242"
    }
  }, [_vm._v("“Holy shit. When did you get shot?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p243"
    }
  }, [_vm._v("“In the war,” Camaro said simply. She glanced at the scar once, then looked away again. She examined the roof of the compartment and the rows of little lights, switched off now, that gave off a soothing yellow glow in the night.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p244"
    }
  }, [_vm._v("“Which war?” Parker asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p245"
    }
  }, [_vm._v("“Both of them,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p246"
    }
  }, [_vm._v("“Both…? You mean like Iraq and Afghanistan both?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p247"
    }
  }, [_vm._v("“Yeah. I was there. Two deployments each.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p248"
    }
  }, [_vm._v("“What branch were you in?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p249"
    }
  }, [_vm._v("“The army.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p250"
    }
  }, [_vm._v("“But you weren’t a "), _c('i', [_vm._v("soldier,")]), _vm._v(" right? I mean, women don’t serve in combat.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p251"
    }
  }, [_vm._v("“Tell that to the Taliban,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("“So you were shooting it out with them? Like with a real rifle and everything?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p253"
    }
  }, [_vm._v("Camaro glared at him. “What do you think women do in the army? We’re not all secretaries. Some of us picked up a weapon once in a while. Some of us picked up a weapon a "), _c('i', [_vm._v("lot")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("“What did you do?” Parker asked. “In the army, I mean.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("“I was a Sixty-Eight Whiskey,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p257"
    }
  }, [_vm._v("“It’s a combat medic. I went out with frontline troops and got it done. Sometimes I got shot at. Sometimes I had to shoot back. If the enemy figured out what I was, I’d be the first one to take fire.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p258"
    }
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p259"
    }
  }, [_vm._v("“You shoot a soldier, you put down that soldier. You put down the medic, and suddenly you put down two, three, four other soldiers. It didn’t matter if it was Iraq or Afghanistan. They both had the same idea.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p260"
    }
  }, [_vm._v("“Jesus,” Parker said. “That’s crazy. And you did this for how long?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p261"
    }
  }, [_vm._v("“I was in twelve years,” Camaro said. “I enlisted right after 9/11. My dad was superpissed. I think he got over it after a while, but…I don’t know.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p262"
    }
  }, [_vm._v("Parker was quiet. Finally, he said, “I never served.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p263"
    }
  }, [_vm._v("“Lots of people don’t.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p264"
    }
  }, [_vm._v("“It’s not because I didn’t want to. I used to play football in high school, you know? Anyway, I didn’t get a bunch of concussions or anything, but I did manage to tear the hell out of my ACL. That was the end of that. No more football, no army, no marines, no nothing. I still can’t run right.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p265"
    }
  }, [_vm._v("Camaro sat up and searched for her watch. She found it at the foot of the bed, swathed in sheets. “I’m running out of time. You’re going to have to get out of here,” she said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p266"
    }
  }, [_vm._v("“What time is it?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p267"
    }
  }, [_vm._v("“Seven thirty.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p268"
    }
  }, [_vm._v("Now Parker sat up and made an angry noise. “Goddamn it, I didn’t tell Lauren I was going to be late tonight. I’m surprised she hasn’t called me already.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p269"
    }
  }, [_vm._v("“Then go. My charter’s going to be here any minute.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p270"
    }
  }, [_vm._v("Parker tried to kiss her, but she turned her head. She got out of bed and put on her clothes. She noticed him watching as she put on her boots. “Is that a knife you have in there?” he asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p271"
    }
  }, [_vm._v("“Yes,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p272"
    }
  }, [_vm._v("“You don’t take any shit from anyone, do you?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p273"
    }
  }, [_vm._v("“Hurry up and get dressed.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p274"
    }
  }, [_vm._v("She went up on the deck while Parker scrambled for his clothes. The day was bleeding away, the sun already low in the west. They would be on their way to the good swordfishing waters by the time it was full dark, and then it would be ten hours out where there were no lights except those of the boat and the distant blink of ships passing miles away on their way to port.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p275"
    }
  }, [_vm._v("Parker stumbled out from inside after a few minutes, still buttoning his shirt. His hair was mussed, and it made him seem younger than he was. He dragged his fingers through it and cleared it away from his face. “I hope this isn’t the last time we, uh, run into each other like this,” he said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p276"
    }
  }, [_vm._v("“No promises,” Camaro said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p277"
    }
  }, [_vm._v("“Okay,” Parker said, and she could hear his disappointment. “I guess that’s it for me, then.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p278"
    }
  }, [_vm._v("Camaro climbed to the flybridge. “Let me know when you’re ready to go out with your people,” she said without turning toward him. “You have the number.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p279"
    }
  }, [_vm._v("“Right,” Parker said. “I will. Good night.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p280"
    }
  }, [_vm._v("He left. Camaro did not watch him go.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad18cbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s009-Chapter-006.vue
// module id = 84
// module chunks = 0